export default "__VITE_ASSET__Dbt5cHHo__"